import "./jquery";

import "@fancyapps/fancybox";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";
$.fancybox.defaults.buttons = ["download", "close"];
